module.exports = __webpack_public_path__ + "img/renew01.eb085c5e.jpeg";